module.exports = __webpack_public_path__ + "media/images/flag-1-a982267f13a651a52662932e97d81931.png";